import { render } from "./AnnualReviewsItem.vue?vue&type=template&id=354c0b46"
import script from "./AnnualReviewsItem.vue?vue&type=script&lang=js"
export * from "./AnnualReviewsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__